class SimpleBarScrollToDirective {
    constructor($timeout) {
        this.restrict = 'A';
        this.$timeout = $timeout;
    }

    link(scope, element, attrs, controllers) {

        const targetId = attrs.target || null;
        
        this.$timeout(() => {
            const simpleBar = element[0].SimpleBar;
            const contentElement = simpleBar.getContentElement();
            const targetElement = angular.element(document.getElementById(targetId)).parent();

            if (!targetElement) return false;

            const offset = targetElement[0].offsetTop;
            const scrollSpace = element[0].offsetHeight;

            if (offset < scrollSpace) return false;

            contentElement.scrollTop = offset;            
        }, 500);
    }

    static directiveFactory($timeout) {
        'ngInject';
        return new SimpleBarScrollToDirective($timeout);
    }
}

export default SimpleBarScrollToDirective;